import React from 'react';
import AllEntitiesFromCategoryModal from './../../../reusable/Modal/AllEntitiesFromCategoryModal';
import SeeAllEntitiesTable from './../Components/SeeAllEntitiesTable';

export default class ModalManageCategoriesSeeAll extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalLoading: true
        };

        this.isLoadingHandler = this.isLoadingHandler.bind(this);
    }

    isLoadingHandler(param) {
        this.setState({isModalLoading: param})
    }

    render = () =>
        <AllEntitiesFromCategoryModal modalName='ModalSeeAllCategories'
                                      isModalLoading={this.state.isModalLoading}
                                      secondaryAction={this.props.secondaryAction}
                                      title={this.props.category.name}>
            <SeeAllEntitiesTable category={this.props.category} isLoadingHandler={this.isLoadingHandler} />
        </AllEntitiesFromCategoryModal>;
}


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/SeeAllEntitiesTableWrapper.jsx